import update from 'immutability-helper'
import {
  GET_NEWS_SUCCESS,
  GET_NEWS_ARTICLE_SUCCESS,
  CLEAR_NEWS_ARTICLE,
  GET_NEWS_FAILURE,
} from '../actions/action-types'

const initialState = {
  adminNews: {
    currentArticle: null,
  },
  userNews: null,
}

// eslint-disable-next-line default-param-last
const assets = (state = initialState, action) => {
  switch (action.type) {
    case GET_NEWS_SUCCESS:
      return update(state, {
        userNews: { $set: action.response },
      })
    case GET_NEWS_FAILURE:
      return update(state, {
        userNews: { $set: { ...state.userNews, error: true } },
      })
    case GET_NEWS_ARTICLE_SUCCESS: {
      return update(state, {
        adminNews: {
          currentArticle: { $set: action.response },
        },
      })
    }
    case CLEAR_NEWS_ARTICLE: {
      return update(state, {
        adminNews: {
          currentArticle: { $set: null },
        },
      })
    }
    default:
      return state
  }
}

export default assets
